import { formatTHB } from '@rrp/shared';

export { formatTHB };

export function fmtPct(p: number | null): string {
  return p === null ? '—' : `${p.toFixed(1)}%`;
}

export function fmtDate(key: string): string {
  const [y, m, d] = key.split('-');
  return `${d}/${m}/${y}`;
}

export function deltaHtml(cur: number, prv: number, compareLabel = 'เทียบงวดก่อน'): string {
  if (prv === 0) return '';
  const pct = ((cur - prv) / Math.abs(prv)) * 100;
  const cls = pct >= 0 ? 'up' : 'down';
  const arrow = pct >= 0 ? '▲' : '▼';
  return `<div class="delta ${cls}">${arrow} ${Math.abs(pct).toFixed(1)}% ${compareLabel}</div>`;
}
